import React from "react";
import { useParams } from "react-router";

import CategoryPageMultiplex from "../components/categories/CategoryPageMultiplex";
import CatalogHubPage from "../components/categories/root/CatalogHubPage";
import { SearchFiltersContextProvider } from "../lib/useSearchFilters";

export default function OnlineClassesPage() {
  const category = useParams<{ themeOrQuery?: string }>()?.themeOrQuery;

  return (
    <SearchFiltersContextProvider>
      {category ? <CategoryPageMultiplex /> : <CatalogHubPage />}
    </SearchFiltersContextProvider>
  );
}
